import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, FormGroup, Form, Input, Row, Col } from "reactstrap";
import Select from 'react-select'
import MaterialTable from 'material-table';
import Switch from 'react-switch';

// style
import { table_translate, table_style } from "../../../../constants/MaterialTable.js";

// helpers
import { showMessage, showQuestion } from "../../../../helpers/message.js";
import { transformValueFormatedtoFloat, transformValueFloattoFormated } from "../../../../helpers/formats.js"
import FormularioFichaQuestoesModalResposta from './ModalRespostas';

// api
import formulariovistoria_api from "../../../../api/formulariovistoria_api.js";
import indiceiqg_api from '../../../../api/indiceiqg_api';

export default function FormularioFichaQuestoes({ setshowLoading, isDisable, formularioVistoria, update }) {

    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });

    // Tipo de Valor
    const options_tipoValor = [
        { label: "Data", value: "Data" },
        { label: "Lista", value: "Lista" },
        { label: "Número", value: "Número" },
        { label: "Texto", value: "Texto" }
    ];
    const [tipoValor, set_tipoValor] = useState(null);
    const handleChangeTipoValor = (value) => {
        set_tipoValor(value);
        clearErrors("tipoValor");
        setValue("tipoValor", value, true);
    }

    // Índices Analíticos de IQG
    const [options_indicesAnaliticosIQG, set_options_indicesAnaliticosIQG] = useState([]);
    const loadOptionsIndicesAnaliticosIQG = () => {
        if (formularioVistoria.indiceIQG_Id == null) return;

        indiceiqg_api.getListaIndiceAnaliticoIQGByIndicePrincipal(formularioVistoria.indiceIQG_Id).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _lista = [{ indiceAnaliticoIQG_Id: null, identificacao: "Nenhum" }, ...result.data];
                set_options_indicesAnaliticosIQG(_lista);
            }
        })
    }
    const [indiceAnaliticoIQG, set_indiceAnaliticoIQG] = useState(null);
    const handleChangeIndiceAnaliticoIQG = (value) => {
        setValue("indiceAnaliticoIQG", value);
        set_indiceAnaliticoIQG(value);
    }

    // Campo Obrigatório
    const [obrigatorio, set_obrigatorio] = useState(false);
    const handleChangeObrigatorio = value => {
        set_obrigatorio(value);
    }

    // Foto Obrigatória
    const [fotoObrigatoria, set_fotoObrigatoria] = useState(false);
    const handleChangeFotoObrigatoria = value => {
        set_fotoObrigatoria(value);
    }

    // Possui Dependência
    const [possuiDependencia, set_possuiDependencia] = useState(false);
    const handleChangePossuiDependencia = value => {
        set_possuiDependencia(value);
    }

    // Opções de Resposta
    const [isOpenModalRespostas, set_isOpenModalRespostas] = useState(false);
    const [formularioVistoriaQuestaoOpcoes, set_formularioVistoriaQuestaoOpcoes] = useState([]);
    const handleReturnQuestaoOpcoes = (data) => {
        set_formularioVistoriaQuestaoOpcoes(data);
        set_isOpenModalRespostas(false);
    }

    // Questão Vinculada
    const [questaoPai, set_questaoPai] = useState(null);
    const handleChangeQuestaoPai = (value) => {
        set_questaoPai(value);
        setValue("questaoPai", value);
    }

    // Lista de Questões
    const [list_table, set_list_table] = useState([]);

    // Edição de Questão
    const [rowEdit, set_rowEdit] = useState(null);
    const handleEdit = (rowData) => {
        set_rowEdit(rowData);
        setValue("sequencia", rowData.sequencia);
        setValue("identificacao", rowData.identificacao);
        set_indiceAnaliticoIQG(rowData.indiceAnaliticoIQG);
        setValue("pesoIQG", transformValueFloattoFormated(rowData.pesoIQG));
        set_tipoValor(rowData.tipoValor);
        setValue("tipoValor", rowData.tipoValor, true);
        set_obrigatorio(rowData.obrigatorio);
        set_fotoObrigatoria(rowData.fotoObrigatoria);
        set_possuiDependencia(rowData.possuiDependencia);

        if (rowData.tipoValor == "Lista")
            set_formularioVistoriaQuestaoOpcoes(rowData.formularioVistoriaQuestaoOpcos);

        if (rowData.possuiDependencia && rowData.formularioVistoriaQuestaoDependentes.length > 0) {
            let _questaoPai = list_table.filter(f => f.formularioVistoriaQuestao_Id == rowData.formularioVistoriaQuestaoDependentes[0].questaoPai_Id)[0];
            set_questaoPai(_questaoPai);
            setValue("questaoPai", _questaoPai, true);
            setValue("questaoPai_Valor", rowData.formularioVistoriaQuestaoDependentes[0].questaoPai_Valor);
        }
        else {
            set_questaoPai(null);
            setValue("questaoPai", "", false);
            setValue("questaoPai_Valor", "");
        }
    }

    // Delete
    const handleDelete = (rowData) => {
        showQuestion("Atenção", "Tem certeza que quer excluir o item?", "question", function (success) {
            if (success) {
                setshowLoading(true);
                formulariovistoria_api.deleteFormularioVistoriaQuestao(rowData.formularioVistoriaQuestao_Id).then(result => {
                    setshowLoading(false);
                    if (result.status !== 200)
                        showMessage("Aviso", result.message, 'error', null);
                    else {
                        showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                            let _list = list_table.filter(f => f.formularioVistoriaQuestao_Id != rowData.formularioVistoriaQuestao_Id);
                            set_list_table(_list);

                            let _formulario = formularioVistoria;
                            _formulario.formularioVistoriaQuestos = _list;
                            update(_formulario);
                        });
                    }
                });
            }
        });
    }

    const loadForm = () => {
        set_list_table(formularioVistoria.formularioVistoriaQuestos);
    }

    useEffect(() => {
        loadOptionsIndicesAnaliticosIQG();
        loadForm();
    }, []);

    const onSubmit = (data) => {
        if (list_table.filter(f => f.sequencia == data.sequencia && rowEdit && rowEdit.formularioVistoriaQuestao_Id != f.formularioVistoriaQuestao_Id).length > 0) {
            showMessage("Aviso", "Já existe uma questão com este número de sequência.", 'error', null);
            return;
        }

        if (tipoValor == "Lista" && formularioVistoriaQuestaoOpcoes.length == 0) {
            showMessage("Aviso", "Informe as opções de resposta da lista.", 'error', null);
            return;
        }

        if (possuiDependencia && !questaoPai) {
            showMessage("Aviso", "Informe a questão vinculada.", 'error', null);
            return;
        }

        let formularioVistoriaQuestaoDependentes = [];
        if (possuiDependencia) {
            formularioVistoriaQuestaoDependentes.push({
                formularioVistoriaQuestaoDependente_Id: rowEdit && rowEdit.formularioVistoriaQuestaoDependentes.length > 0 ? rowEdit.formularioVistoriaQuestaoDependentes[0].formularioVistoriaQuestaoDependente_Id : 0,
                questaoPai_Id: questaoPai.formularioVistoriaQuestao_Id,
                formularioVistoriaQuestao_Id: rowEdit ? rowEdit.formularioVistoriaQuestao_Id : 0,
                questaoPai_Valor: data.questaoPai_Valor
            })
        }

        let json_submit = {
            formularioVistoriaQuestao_Id: rowEdit ? rowEdit.formularioVistoriaQuestao_Id : 0,
            formularioVistoria_Id: formularioVistoria.formularioVistoria_Id,
            sequencia: data.sequencia,
            identificacao: data.identificacao,
            indiceAnaliticoIQG_Id: indiceAnaliticoIQG ? indiceAnaliticoIQG.indiceAnaliticoIQG_Id : null,
            pesoIQG: transformValueFormatedtoFloat(data.pesoIQG),
            tipoValor: tipoValor,
            obrigatorio: obrigatorio,
            fotoObrigatoria: fotoObrigatoria,
            possuiDependencia: possuiDependencia,
            formularioVistoriaQuestaoOpcos: formularioVistoriaQuestaoOpcoes,
            formularioVistoriaQuestaoDependentes: formularioVistoriaQuestaoDependentes.length > 0 ? formularioVistoriaQuestaoDependentes : null
        }

        setshowLoading(true);
        if (json_submit.formularioVistoriaQuestao_Id == 0)
            formulariovistoria_api.postFormularioVistoriaQuestao(json_submit).then(result => handleReturnSubmit(result));
        else
            formulariovistoria_api.putFormularioVistoriaQuestao(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                // Atualiza a lista local
                let _list = list_table.filter(f => f.formularioVistoriaQuestao_Id != result.data.formularioVistoriaQuestao_Id);
                _list.push(result.data);
                _list.sort((a, b) => (a.sequencia > b.sequencia) ? 1 : ((b.sequencia > a.sequencia) ? -1 : 0));
                set_list_table(_list);

                // Atualiza a state principal
                let _formulario = formularioVistoria;
                _formulario.formularioVistoriaQuestos = _list;
                update(_formulario);

                // Limpa campos da tela
                setValue("sequencia", "");
                setValue("identificacao", "");
                set_tipoValor(null);
                setValue("tipoValor", "", false);
                set_indiceAnaliticoIQG(null);
                setValue("pesoIQG", "");
                set_obrigatorio(false);
                set_fotoObrigatoria(false);
                set_possuiDependencia(false);
                set_formularioVistoriaQuestaoOpcoes(null);
                set_questaoPai(null);
                setValue("questaoPai", "", false);
                setValue("questaoPai_Valor", "");
                set_rowEdit(null);
            });
        }
    }

    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="align-items-end">
                    <Col lg="2" md="4" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Sequência</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="number"
                                name="sequencia"
                                innerRef={register({ required: true })}
                                disabled={isDisable}
                            />
                            {errors.sequencia && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="10" md="8" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Identificação</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="identificacao"
                                innerRef={register({ required: true })}
                                disabled={isDisable}
                            />
                            {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="3" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Índice Analítico de IQG</label>
                            <Select
                                name="indiceAnaliticoIQG"
                                options={options_indicesAnaliticosIQG}
                                getOptionLabel={o => o.identificacao}
                                getOptionValue={o => o.indiceAnaliticoIQG_Id}
                                value={indiceAnaliticoIQG}
                                onChange={(o) => handleChangeIndiceAnaliticoIQG(o)}
                                classNamePrefix="select"
                                placeholder="Nenhum"
                                ref={e => register(
                                    { name: "indiceAnaliticoIQG" },
                                    { required: false })
                                }
                                isDisabled={isDisable}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="3" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Peso IQG</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="decimal"
                                name="pesoIQG"
                                innerRef={register({ required: indiceAnaliticoIQG })}
                                disabled={isDisable}
                            />
                            {indiceAnaliticoIQG && errors.pesoIQG && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="3" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Tipo de valor</label>
                            <Select
                                name="tipoValor"
                                options={options_tipoValor}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_tipoValor.filter(f => f.value == tipoValor)}
                                onChange={(o) => handleChangeTipoValor(o.value)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register(
                                    { name: "tipoValor" },
                                    { required: true })
                                }
                                isDisabled={isDisable}
                            />
                            {errors.tipoValor && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="3" md="6" sm="12" className={tipoValor == "Lista" ? "pt-2 text-center" : "d-none"}>
                        <Button color="info" type="button" onClick={() => set_isOpenModalRespostas(true)}>
                            <i className="fas fa-file-alt"></i> Opções de Resposta
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col lg="4" md="6" sm="12">
                        <FormGroup>
                            <label htmlFor="obrigatorio">
                                <span>Campo obrigatório</span><br />
                                <Switch name="obrigatorio"
                                    id="obrigatorio"
                                    className="react-switch"
                                    checked={obrigatorio}
                                    onChange={handleChangeObrigatorio}
                                    onColor="#86d3ff"
                                    onHandleColor="#2693e6"
                                    disabled={isDisable}
                                />
                            </label>
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="6" sm="12">
                        <FormGroup>
                            <label htmlFor="fotoObrigatoria">
                                <span>Foto obrigatória</span><br />
                                <Switch name="fotoObrigatoria"
                                    id="fotoObrigatoria"
                                    className="react-switch"
                                    checked={fotoObrigatoria}
                                    onChange={handleChangeFotoObrigatoria}
                                    onColor="#86d3ff"
                                    onHandleColor="#2693e6"
                                    disabled={isDisable}
                                />
                            </label>
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="6" sm="12">
                        <FormGroup>
                            <label htmlFor="possuiDependencia">
                                <span>Possui dependência</span><br />
                                <Switch name="possuiDependencia"
                                    id="possuiDependencia"
                                    className="react-switch"
                                    checked={possuiDependencia}
                                    onChange={handleChangePossuiDependencia}
                                    onColor="#86d3ff"
                                    onHandleColor="#2693e6"
                                    disabled={isDisable}
                                />
                            </label>
                        </FormGroup>
                    </Col>
                </Row>
                <Row className={possuiDependencia ? "" : "d-none"}>
                    <Col lg="6" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Questão vinculada</label>
                            <Select
                                name="questaoPai"
                                options={list_table.filter(f => (rowEdit && f.formularioVistoriaQuestao_Id != rowEdit.formularioVistoriaQuestao_Id) || rowEdit == null)}
                                getOptionLabel={o => o.identificacao}
                                getOptionValue={o => o.formularioVistoriaQuestao_Id}
                                value={questaoPai}
                                onChange={(o) => handleChangeQuestaoPai(o)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register(
                                    { name: "questaoPai" },
                                    { required: possuiDependencia })
                                }
                                isDisabled={isDisable}
                            />
                            {possuiDependencia && errors.questaoPai && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="6" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Valor da questão vinculada</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="questaoPai_Valor"
                                innerRef={register({ required: false })}
                                disabled={isDisable}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                {!isDisable &&
                    <Row>
                        <Col lg="12" md="12" sm="12" className="text-center">
                            <Button color="success" type="submit">
                                <i className="fas fa-plus"></i> Adicionar
                            </Button>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col lg="12">
                        <MaterialTable style={{ minHeight: "auto" }}
                            title="Lista de Questões"
                            columns={[
                                { title: 'Sequência', field: 'sequencia' },
                                { title: 'Identificação', field: 'identificacao' },
                                { title: 'Índice IQG', field: 'indiceAnaliticoIQG.identificacao' },
                                { title: 'Peso IQG', render: (rowData) => rowData.pesoIQG != null ? transformValueFloattoFormated(rowData.pesoIQG) : null },
                                { title: 'Tipo de valor', field: 'tipoValor' },
                                { title: 'Campo obrigatório', render: (rowData) => rowData.obrigatorio ? "Sim" : "Não" },
                                { title: 'Foto obrigatória', render: (rowData) => rowData.fotoObrigatoria ? "Sim" : "Não" }
                            ]}
                            data={list_table}
                            isLoading={false}
                            options={{
                                ...table_style,
                                filtering: false,
                                exportButton: true
                            }}
                            actions={[
                                {
                                    icon: 'edit',
                                    tooltip: 'Editar Registro',
                                    onClick: (event, rowData) => handleEdit(rowData)
                                },
                                {
                                    icon: 'delete',
                                    tooltip: 'Remover',
                                    onClick: (event, rowData) => handleDelete(rowData)
                                }
                            ]}
                            localization={table_translate}
                        />
                    </Col>
                </Row>
            </Form>
            <FormularioFichaQuestoesModalResposta
                isOpen={isOpenModalRespostas}
                isDisable={isDisable}
                formularioVistoriaQuestao_Id={rowEdit ? rowEdit.formularioVistoriaQuestao_Id : 0}
                formularioVistoriaQuestaoOpcoes={formularioVistoriaQuestaoOpcoes}
                handleReturn={handleReturnQuestaoOpcoes}
            />
        </>
    );
}

